import React from "react";
import PropTypes from "prop-types";
import { Typography, Slider } from "antd";

import styles from "./styles.module.scss";

const { Text } = Typography;

export default function InputSlider({
  label,
  value = 0,
  onChange,
  min,
  max,
  name,
  step,
}) {
  const handleOnChange = (arg) => onChange({ target: { value: arg, name } });

  return (
    <div className={styles.InputSlider}>
      <Text className={styles.Label}>{label}</Text>
      <Slider
        onChange={handleOnChange}
        value={value}
        min={min}
        max={max}
        step={step}
      />
    </div>
  );
}

InputSlider.defaultProps = {
  label: "",
  step: 1,
  onChange: () => {},
};

InputSlider.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  step: PropTypes.number,
};
